export const Sparkline = ({ points, up }) => {
  if (!points?.length) return null;
  const min = Math.min(...points), max = Math.max(...points);
  const range = max - min || 1;
  const d = points.map((p, i) => `${(i / (points.length - 1)) * 100},${30 - ((p - min) / range) * 28 - 1}`).join(" ");
  return (
    <svg viewBox="0 0 100 30" preserveAspectRatio="none" className="w-full h-14" data-testid="btc-sparkline">
      <polyline points={d} fill="none" stroke={up ? "#34D399" : "#F87171"} strokeWidth="1.2" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};
